// 路由懒加载
import { lazy } from 'react';

const EnvImage = lazy(() => import('./EnvImage'))
const Login = lazy(() => import('./Login'))
const Home = lazy(() => import('./Home'))
const Staff = lazy(() => import('./Staff/Index'))
const StaffList = lazy(() => import('./Staff/List'))
const StaffDetail = lazy(() => import('./Staff/Detail'))
const Activity = lazy(()=> import('./activity/Index'))
const ActivityList = lazy(()=> import('./activity/List'))
const ActivityDetail = lazy(()=> import('./activity/Detail'))
const Res = lazy(() => import('./res/Index'))
const ResList = lazy(() => import('./res/List'))
const ResDetail = lazy(() => import('./res/Detail'))
const KinderDetail = lazy(() => import('./kinder/Detail'))
const XnsyList = lazy(() => import('./xnsy/List'))
const XnsyDetail = lazy(() => import('./xnsy/Detail'))
const XnsyReport = lazy(() => import('./xnsy/Report'))

export {
  EnvImage,
  Home,
  Login,
  Staff,
  StaffList,
  StaffDetail,
  Activity,
  ActivityList,
  ActivityDetail,
  Res,
  ResList,
  ResDetail,
  KinderDetail,
  XnsyList,
  XnsyDetail,
  XnsyReport
}